import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import BeerStyle from 'typescript/models/BeerStyle';

interface IState {
  beerStyles: BeerStyle[];
  totalPages: number;
  totalCount: number;
  checkedBeerStyles: string[];
  beerStyleFilters: {page: number; order: 'asc' | 'desc'; name: string; per_page: number};
}

const initialState: IState = {
  beerStyles: [],
  totalPages: 0,
  totalCount: 0,
  checkedBeerStyles: [],
  beerStyleFilters: {page: 1, per_page: 15, order: 'asc', name: ''},
};

export const beerStylesNamespace = 'beerStyles';

const beerStyleSlice = createSlice({
  name: beerStylesNamespace,
  initialState,
  reducers: {
    setBeerStylesAC: (state, action: PayloadAction<IState['beerStyles']>) => {
      state.beerStyles = action.payload;
    },
    setBeerStylePageDataAC: (state, action: PayloadAction<{totalPages: number; totalCount: number}>) => {
      state.totalPages = action.payload.totalPages;
      state.totalCount = action.payload.totalCount;
    },
    setNewBeerStyleAC: (state, action: PayloadAction<BeerStyle>) => {
      state.beerStyles.push(action.payload);
    },

    setUpdatedBeerStyleAC: (state, action: PayloadAction<BeerStyle>) => {
      state.beerStyles = state.beerStyles.map((style: BeerStyle) =>
        style.id === action.payload.id ? action.payload : style,
      );
    },
    switchSortOrderAC: (state) => {
      if (state.beerStyleFilters.order === 'asc') state.beerStyleFilters.order = 'desc';
      else state.beerStyleFilters.order = 'asc';
    },
    checkedBeerStylesAC: (state, action: PayloadAction<IState['checkedBeerStyles']>) => {
      state.checkedBeerStyles = action.payload;
    },
    setBeerStyleFiltersAC: (state, action: PayloadAction<IState['beerStyleFilters']>) => {
      state.beerStyleFilters = action.payload;
    },
  },
});

export default beerStyleSlice;

export const {
  checkedBeerStylesAC,
  setBeerStylesAC,
  setBeerStylePageDataAC,
  setNewBeerStyleAC,
  setUpdatedBeerStyleAC,
  switchSortOrderAC,
  setBeerStyleFiltersAC,
} = beerStyleSlice.actions;
